import React from 'react';
import { ButtonView } from '@vivli/shared/views';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { useModalApiContext } from '@vivli/core/infrastructure/context';

interface ShowApprovalButtonsComponentProps {
    message: string;
    title: string;
}

export const ShowApprovalButtonsComponent = ({ message, title }: ShowApprovalButtonsComponentProps) => {
    const { setShowApprovalButtons, isUpdatingStatus } = useDataRequestContext();
    const modalService = useModalApiContext();

    const handleButtonClick = () => {
        modalService.confirm(message, {
            title: 'Confirm Override?',
            onConfirm: () => setShowApprovalButtons(true),
        });
    };

    const dataId = DTICommonConst.HeaderApprovalButton(`${title.toLowerCase().replace(/ /g, '_')}`);

    return (
        <ButtonView style={{ marginLeft: 10 }} onClick={handleButtonClick} disabled={isUpdatingStatus} dataId={dataId}>
            {title}
        </ButtonView>
    );
};
